import { render, staticRenderFns } from "./b-ticket-personal-details.vue?vue&type=template&id=2381477f&scoped=true"
import script from "./b-ticket-personal-details.vue?vue&type=script&lang=ts"
export * from "./b-ticket-personal-details.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-personal-details.vue?vue&type=style&index=0&id=2381477f&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2381477f",
  null
  
)

export default component.exports